import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

import { environment } from "../../../../../environments/environment";
import { CommonService } from "../../common-service";
import { BookCreditAcquisitionRequest } from "../../requests/platform/book-credit-acquisition.request";
import { CreditAcquisitionResponse } from "../../responses/platform/credit-acquisition.response";

@Injectable({ providedIn: "root" })
export class BookReviewCreditAcquisitionService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  public createAcquisition(
    request: BookCreditAcquisitionRequest
  ): Observable<CreditAcquisitionResponse> {
    return this.http
      .post<CreditAcquisitionResponse>(
        environment.urlApiPlatform + "BookReviewCreditAcquisition",
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public GetStatusCreditAquisition(idBookVersion: number, idStatusVersion: number): Observable<CreditAcquisitionResponse> {
    return this.http
      .get<CreditAcquisitionResponse>(environment.urlApiPlatform + "BookReviewCreditAcquisition/last/idBookVersion/" + idBookVersion, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
